// @ts-ignore
import content from './md/postcard-marketing-home-services.md';

export const meta = {
  slug: 'postcard-marketing-home-services',
  title: 'Automated Postcard Marketing: A Game-Changer for Home Service Businesses',
  excerpt: 'Learn how automated postcard campaigns can help you reach potential customers in the neighborhoods where you already work, leveraging the power of social proof and geographic proximity.',
  date: 'January 2025',
  readTime: '10 min read',
  image: '/docs/postcard-marketing/header.png'
};

export { content };
